<template>
  <el-dialog
    title="选择班级联络员"
    :visible.sync="showSelectLiaison.flag"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <div class="main-dailog">
      <div class="left">
      <el-input
        class="search-dept"
        v-model.trim="departmentName"
        @input="searchDep"
        size="small"
        placeholder="请输入部门名称"
      />
      <el-tree
        class="dept-tree"
        :data="deptList"
        :props="props"
        show-checkbox
        highlight-current
        :expand-on-click-node="false"
        :default-expanded-keys="defaultExpandedKeys"
        :filter-node-method="filterNode"
        @check-change="handleCheckChange"
        node-key="id"
        ref="deptTree"
      >
      </el-tree>
    </div>
    <div class="right">
      <div class="right-table">
        <div class="top-filter">
          <el-input
            v-model="name"
            placeholder="请输入名字"
            size="small"
            class="name-input"
          ></el-input>
          <el-button type="primary" @click="queryClick" size="small">查询</el-button>
          <el-button type="primary" @click="resetClick" size="small">重置</el-button>
        </div>
        <el-table
          ref="pageListTable"
          border
          :data="tableData"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection"  :reserve-selection="true" width="40" :selectable="isDisable">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="单位"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="unitPosition"
            label="单位及职务"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    </div>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="showSelectLiaison.flag = false" size="small">取 消</el-button>
      <el-button type="primary" @click="selectUser" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import vue from "../../../main";
import { liaisonTree } from "@/api/dept";
import { getLiaisonUserList } from "@/api/classOffline";
import { throttle } from "@/utils/common.js";
export default {
  props: ["liaisonUserIds", "showSelectLiaison"],
  data() {
    return {
      getRowKeys(row) {
				return row.uuid;
			},
      departmentName: "",
      deptList: [],
      tableData: [],
      currentPage: 1,
      total: 0,
      size: 10,
      name: '',
      multipleSelection: [],
      props: {
        label: "name",
        children: "children",
      },
    };
  },
  created() {
    liaisonTree().then((res) => {
      if (!res || res.code != 0) return;
      if (res.data.length > 0) {
        this.deptList = res.data;
      }
    });
    const _this = this;
    _this.name = '',
    _this.tableData = [];
    _this.total = 0;
    _this.currentPage = 1;
  },
  mounted() {
    
  },
  computed: {
    defaultExpandedKeys() {
      return this.deptList.length > 0 ? [this.deptList[0].id] : [];
    },
  },
  methods: {
    isDisable(row) {
      // if (this.needDisable) {
      //   return !this.notSetIds.includes(row.uuid);
      // } else {
        
      // }
      return true;
    },
    // 点击确定
    selectUser() {
      let params = {};
      let ids = [];
      this.multipleSelection.forEach(item => {
        ids.push(item.uuid);
      })
      params.liaisonUserIds = ids;
      params.liaisonUserNames = this.multipleSelection.map(e => e.userName).join(',');
      this.$emit("enrollLisisonSelected", params);
      this.showSelectLiaison.flag = false;
    },
    searchDep(val) {
      this.$refs.deptTree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    // 点击左侧筛选
    handleCheckChange: throttle(function () {
      this.currentPage = 1;
      this.getList();

    }, 200),
    // 点击查询
    queryClick() {
      this.currentPage = 1;
      this.getList();
    },
    resetClick() {
      this.name = '';
      this.$refs['deptTree'].setCheckedKeys([]);
      this.$refs.pageListTable.clearSelection();
    },
    getList () {
      let ids = this.$refs["deptTree"].getCheckedKeys()
      let idsNew = '';
      if (ids.length > 0) {
        idsNew = ids.join(',');
      }
      let params = {
        deptIds: idsNew,
        page: this.currentPage,
        limit: 10,
        userName: this.name
      };
      getLiaisonUserList(params).then( res => {
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.records;
          let rows = [];
          this.tableData.forEach((x, i) => {
            if (Array.from(this.liaisonUserIds).includes(x.uuid)) {
              rows.push(this.tableData[i]);
            }
          });
          setTimeout(() => {
            rows.forEach((row) => {
              this.$refs.pageListTable.toggleRowSelection(row, true);
            });
          }, 200);
        }
      })

    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    max-height: 650px;
    padding: 0;
    margin: 20px;
    }
.main-dailog{
  display: flex;
}
.left {
  margin-right: 10px;
}
.search-dept {
  font-size: 12px;
  margin-bottom: 10px;
}

.dept-tree {
  width: 300px;
  max-height: 550px;
  overflow-y: auto;
}

.right-table {
  flex: 1;
}
.top-filter {
  margin-bottom: 10px;
}
.pagination {
  float: right;
}
.name-input {
  width: 250px;
  margin-right: 10px;
}
</style>
